import styled from 'styled-components';
import { em } from 'polished';
import { colors } from 'core/theme';

export const StyledInput = styled.input`
  background-color: ${colors.background};
  border: 1px solid ${colors.hairline};
  display: block;
  font-size: 1em !important;
  min-height: ${em(42)};
  padding: 0.5em 1em 0.4em;
  text-align: left;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/TextInput/styled.js